module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-FurryBall-Web-640.2a076eee.jpg";